module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSearch.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "searchBar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('message.searchText') + '...'
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "label": "Search"
    },
    on: {
      "click": _vm.onSearch
    }
  })], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75701cc3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LifeStyle/LifeSearchBar/LifeSearchBar.vue
// module id = 3785
// module chunks = 1